/** The document kinds Colistiers issues: the candidate files and forms (not offered for public download). The label is `colistiersApp.documentKinds.CAN`. */
export const COLISTIERS_DOCUMENT_KINDS = ["CAN"] as const;
export type ColistiersDocumentKind = (typeof COLISTIERS_DOCUMENT_KINDS)[number];
export const colistiersDocumentKinds = COLISTIERS_DOCUMENT_KINDS.map((kind) => ({ kind, labelKey: `colistiersApp.documentKinds.${kind}` }));
